const GET_CATALOG_MANAGEMENT_GRID_DATA = 'GET_CATALOG_MANAGEMENT_GRID_DATA';
const SET_CATALOG_MANAGEMENT_GRID_DATA = 'SET_CATALOG_MANAGEMENT_GRID_DATA';

const GET_CATALOG_EQUIPMENT_GRID_DATA = 'GET_CATALOG_EQUIPMENT_GRID_DATA';
const SET_CATALOG_EQUIPMENT_GRID_DATA = 'SET_CATALOG_EQUIPMENT_GRID_DATA';

const GET_CATALOG_MANAGEMENT_GRID_COUNT = 'GET_CATALOG_MANAGEMENT_GRID_COUNT';
const SET_CATALOG_MANAGEMENT_GRID_COUNT = 'SET_CATALOG_MANAGEMENT_GRID_COUNT';
const GET_UPFIT_OPTION_DROPDOWN = 'GET_UPFIT_OPTION_DROPDOWN';
const SET_UPFIT_OPTION_DROPDOWN = 'SET_UPFIT_OPTION_DROPDOWN';

const GET_MAKE_DROPDOWN = 'GET_MAKE_DROPDOWN';
const SET_MAKE_DROPDOWN = 'SET_MAKE_DROPDOWN';

const GET_MODEL_DROPDOWN_LIST = 'GET_MODEL_DROPDOWN_LIST';
const SET_MODEL_DROPDOWN_LIST = 'SET_MODEL_DROPDOWN_LIST';

const GET_FUEL_TYPE_DROPDOWN = 'GET_FUEL_TYPE_DROPDOWN';
const SET_FUEL_TYPE_DROPDOWN = 'SET_FUEL_TYPE_DROPDOWN';

const GET_EQ_CLASS_CODE_DROPDOWN = 'GET_EQ_CLASS_CODE_DROPDOWN';
const SET_EQ_CLASS_CODE_DROPDOWN = 'SET_EQ_CLASS_CODE_DROPDOWN';

const GET_CATALOG_STATUS_DROPDOWN = 'GET_CATALOG_STATUS_DROPDOWN';
const SET_CATALOG_STATUS_DROPDOWN = 'SET_CATALOG_STATUS_DROPDOWN';

const GET_DRIVE_TRAIN_DROPDOWN = 'GET_DRIVE_TRAIN_DROPDOWN';
const SET_DRIVE_TRAIN_DROPDOWN = 'SET_DRIVE_TRAIN_DROPDOWN';
const GET_MODEL_YEAR_DROPDOWN = 'GET_MODEL_YEAR_DROPDOWN';
const SET_MODEL_YEAR_DROPDOWN = 'SET_MODEL_YEAR_DROPDOWN';
const GET_VEHICLE_TYPE_DROPDOWN_LIST = 'GET_VEHICLE_TYPE_DROPDOWN_LIST';
const SET_VEHICLE_TYPE_DROPDOWN_LIST = 'SET_VEHICLE_TYPE_DROPDOWN_LIST';
const GET_MANUFACTURER_DROPDOWN_LIST = 'GET_MANUFACTURER_DROPDOWN_LIST';
const SET_MANUFACTURER_DROPDOWN_LIST = 'SET_MANUFACTURER_DROPDOWN_LIST';

const GET_UPDATED_BY_DROPDOWN_LIST = 'GET_UPDATED_BY_DROPDOWN_LIST';
const SET_UPDATED_BY_DROPDOWN_LIST = 'SET_UPDATED_BY_DROPDOWN_LIST';

const GET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID = 'GET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID';
const SET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID = 'SET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID'
const GET_CATEGORY_DROPDOWN_LIST = 'GET_CATEGORY_DROPDOWN_LIST';
const SET_CATEGORY_DROPDOWN_LIST = 'SET_CATEGORY_DROPDOWN_LIST';

const GET_LENGTH_DROPDOWN_LIST = 'GET_LENGTH_DROPDOWN_LIST';
const SET_LENGTH_DROPDOWN_LIST = 'SET_LENGTH_DROPDOWN_LIST';

const GET_SEATING_CAPACITY_DROPDOWN_LIST = 'GET_SEATING_CAPACITY_DROPDOWN_LIST';
const SET_SEATING_CAPACITY_DROPDOWN_LIST = 'SET_SEATING_CAPACITY_DROPDOWN_LIST';

const GET_MODELS_BASED_ON_MAKE = 'GET_MODELS_BASED_ON_MAKE'
const SET_MODELS_BASED_ON_MAKE = 'SET_MODELS_BASED_ON_MAKE'

const GET_EQUIPMENT_MODELS_BASED_ON_MAKE = 'GET_EQUIPMENT_MODELS_BASED_ON_MAKE'

const SAVE_CATALOG_ITEM = 'SAVE_CATALOG_ITEM'
const IS_CATALOG_ITEM_SAVED = 'IS_CATALOG_ITEM_SAVED'

const GET_CATALOG_ITEM_BY_ASSET_MODEL_ID = 'GET_CATALOG_ITEM_BY_ASSET_MODEL_ID'
const SET_CATALOG_ITEM_BY_ASSET_MODEL_ID = 'SET_CATALOG_ITEM_BY_ASSET_MODEL_ID'

const GET_CATEGORY2_BASED_ON_CATEGORY = 'GET_CATEGORY2_BASED_ON_CATEGORY'
const SET_CATEGORY2_BASED_ON_CATEGORY = 'SET_CATEGORY2_BASED_ON_CATEGORY'

const GET_CATEGORY_TYPE_BASED_ON_CATEGORY = 'GET_CATEGORY_TYPE_BASED_ON_CATEGORY'
const SET_CATEGORY_TYPE_BASED_ON_CATEGORY = 'SET_CATEGORY_TYPE_BASED_ON_CATEGORY'

const GET_CATALOG_DASHBOARD_EXCEL_DATA = 'GET_CATALOG_DASHBOARD_EXCEL_DATA'
const SET_CATALOG_DASHBOARD_EXCEL_DATA = 'SET_CATALOG_DASHBOARD_EXCEL_DATA'

const VALIDATE_SELECTED_VEHICLE_LEVELS = 'VALIDATE_SELECTED_LEVELS'
const IS_SELECTED_VEHICLE_LEVELS_VALID = 'IS_SELECTED_VEHICLE_LEVELS_VALID'

const GET_ASSET_TYPE_OPTIONS = 'GET_ASSET_TYPE_OPTIONS'
const SET_ASSET_TYPE_OPTIONS = 'SET_ASSET_TYPE_OPTIONS' 

const GET_EQ_CLASS_CODE_EXAMPLE = 'GET_EQ_CLASS_CODE_EXAMPLE'
const SET_EQ_CLASS_CODE_EXAMPLE = 'SET_EQ_CLASS_CODE_EXAMPLE'

export
{
    GET_CATALOG_MANAGEMENT_GRID_DATA,
    SET_CATALOG_MANAGEMENT_GRID_DATA,
    GET_CATALOG_EQUIPMENT_GRID_DATA,
    SET_CATALOG_EQUIPMENT_GRID_DATA,
    GET_CATALOG_MANAGEMENT_GRID_COUNT,
    SET_CATALOG_MANAGEMENT_GRID_COUNT,
    GET_UPFIT_OPTION_DROPDOWN,
    SET_UPFIT_OPTION_DROPDOWN,
    GET_MAKE_DROPDOWN,
    SET_MAKE_DROPDOWN,
    GET_MODEL_DROPDOWN_LIST,
    SET_MODEL_DROPDOWN_LIST,
    GET_FUEL_TYPE_DROPDOWN,
    SET_FUEL_TYPE_DROPDOWN,
    GET_EQ_CLASS_CODE_DROPDOWN,
    SET_EQ_CLASS_CODE_DROPDOWN,
    GET_CATALOG_STATUS_DROPDOWN,
    SET_CATALOG_STATUS_DROPDOWN,
    GET_DRIVE_TRAIN_DROPDOWN,
    SET_DRIVE_TRAIN_DROPDOWN,
    GET_MODEL_YEAR_DROPDOWN,
    SET_MODEL_YEAR_DROPDOWN,
    GET_VEHICLE_TYPE_DROPDOWN_LIST,
    SET_VEHICLE_TYPE_DROPDOWN_LIST,
    GET_UPDATED_BY_DROPDOWN_LIST,
    SET_UPDATED_BY_DROPDOWN_LIST,
    GET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID,
    SET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID,
    GET_CATEGORY_DROPDOWN_LIST,
    SET_CATEGORY_DROPDOWN_LIST,
    GET_MANUFACTURER_DROPDOWN_LIST,
    SET_MANUFACTURER_DROPDOWN_LIST,
    GET_LENGTH_DROPDOWN_LIST,
    SET_LENGTH_DROPDOWN_LIST,
    GET_SEATING_CAPACITY_DROPDOWN_LIST,
    SET_SEATING_CAPACITY_DROPDOWN_LIST,
    GET_MODELS_BASED_ON_MAKE,
    SET_MODELS_BASED_ON_MAKE,
    SAVE_CATALOG_ITEM,
    IS_CATALOG_ITEM_SAVED,
    GET_CATALOG_ITEM_BY_ASSET_MODEL_ID,
    SET_CATALOG_ITEM_BY_ASSET_MODEL_ID,
    GET_EQUIPMENT_MODELS_BASED_ON_MAKE,
    GET_CATEGORY2_BASED_ON_CATEGORY,
    SET_CATEGORY2_BASED_ON_CATEGORY,
    GET_CATEGORY_TYPE_BASED_ON_CATEGORY,
    SET_CATEGORY_TYPE_BASED_ON_CATEGORY,
    GET_CATALOG_DASHBOARD_EXCEL_DATA,
    SET_CATALOG_DASHBOARD_EXCEL_DATA,
    VALIDATE_SELECTED_VEHICLE_LEVELS,
    IS_SELECTED_VEHICLE_LEVELS_VALID,
    GET_ASSET_TYPE_OPTIONS,
    SET_ASSET_TYPE_OPTIONS,
    GET_EQ_CLASS_CODE_EXAMPLE,
    SET_EQ_CLASS_CODE_EXAMPLE
};